<template lang="pug">
#MobileMenu
  b-navbar.px-0(sticky)
    b-nav.pb-2(vertical)
      b-nav-item.section-title {{activeSection}}
      b-nav-item-dropdown(boundary="viewport")
        template(v-slot:button-content)
          span.drop-text {{activeSubsection}}
        b-dropdown-header.section(v-for="(section, index) in sections" ) {{section.title}}
          b-dropdown-divider
          b-dropdown-item.subsection( v-for="(subsection, subindex) in section.subsections" :href="'#s' + (index + 1) +'s' + (subindex + 1)" @click="activeLink(index, subindex)") {{subsection.title}}
    b-navbar-brand.ml-auto
      img.logo-mvdf(src="/assets/logos/mvdf-logo.svg")
      img.logo-ceav(src="/assets/logos/CEAV_logo_blanco.svg")
    

        
       



    
    
</template>

<script>
export default {
  name: "MobileMenu",
  data() {
    return {
      sectionsIds: {
        section1: "Antecedentes",
        section2: "Hechos 1972 - 1976",
        section3: "Consecuencias 1976 a la fecha",
        section4: "MVDF"
      },
      subsectionsIds: {
        s1s1: "Orígenes y Luchas, Movimientos Agraristas y Vidalismo",
        s1s2: "Fundación de El Quemado",
        s1s3: "Insurgencia y Contrainsurgencia",
        s2s1: "Verano de 1972",
        s2s2: "Inicio de Hechos en El Quemado",
        s2s3: "Extracción y Encarcelamiento",
        s2s4: "Las Familias en El Quemado",
        s2s5: "La vida en la cárcel",
        s2s6: "Liberación",
        s3s1: "Consecuencias 1976 a la fecha",
        s3s2: "Proceso de Reparación con CEAV",
        s4s1: "MVDF"
      },
      sections: [
        {
          number: 1,
          title: "Antecedentes",
          slug: "antecedentes",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "Orígenes y Luchas, Movimientos Agraristas y Vidalismo",
              slug: "orígenes",
              active: false
            },
            {
              number: 2,
              title: "Fundación de El Quemado",
              slug: "fundación",
              active: false
            },
            {
              number: 3,
              title: "Insurgencia y Contrainsurgencia",
              slug: "insurgencia",
              active: false
            }
          ]
        },
        {
          number: 2,
          title: "Hechos 1972 - 1976",
          slug: "hechos",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "Verano de 1972",
              slug: "verano",
              active: false
            },
            {
              number: 2,
              title: "Inicio de Hechos en El Quemado",
              slug: "inicio-hechos",
              active: false
            },
            {
              number: 3,
              title: "Extracción y Encarcelamiento",
              slug: "encarcelamiento",
              active: false
            },
            {
              number: 4,
              title: "Las Familias en El Quemado",
              slug: "familias",
              active: false
            },
            {
              number: 5,
              title: "La vida en la cárcel",
              slug: "vida-cárcel",
              active: false
            },
            {
              number: 6,
              title: "Liberación",
              slug: "liberación",
              active: false
            }
          ]
        },
        {
          number: 3,
          title: "Consecuencias 1976 a la fecha",
          slug: "consecuencias-1976",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "Consecuencias 1976 a la fecha",
              slug: "consecuencias",
              active: false
            },
            // {
            //   number: 2,
            //   title: "1980s-2000s, EPR",
            //   slug: "epr",
            //   active: false
            // },
            // {
            //   number: 3,
            //   title: "FEMOSPP",
            //   slug: "femospp",
            //   active: false
            // },
            // {
            //   number: 4,
            //   title: "COMVERDAD",
            //   slug: "comverdad",
            //   active: false
            // },
            // {
            //   number: 5,
            //   title: "Revictimización",
            //   slug: "revictimización",
            //   active: false
            // },
            // {
            //   number: 5,
            //   title: "Cuarta fundación de El Quemado",
            //   slug: "cuarta-fundación",
            //   active: false
            // },
            {
              number: 6,
              title: "Proceso de Reparación con CEAV",
              slug: "reparación",
              active: false
            }
          ]
        },
        {
          number: 4,
          title: "MVDF",
          slug: "mvdf",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "MVDF",
              slug: "mvdf",
              active: false
            }
          ]
        }
      ]
    };
  },
  computed: {
    sectionId: {
      get() {
        return this.$store.state.sectionId;
      },
      set(value) {
        this.$store.state.sectionId = value;
      }
    },
    subsectionId: {
      get() {
        return this.$store.state.subsectionId;
      },
      set(value) {
        this.$store.state.subsectionId = value;
      }
    },
    activeSection() {
      return this.sectionsIds[this.sectionId];
    },
    activeSubsection() {
      return this.subsectionsIds[this.subsectionId];
    }
  },
  methods: {
    activeLink(chosenSection, chosenSub) {
      this.sectionId = "section" + (chosenSection + 1);
      this.subsectionId = "s" + (chosenSection + 1) + "s" + (chosenSub + 1);
      const sections = document.querySelectorAll(".dropdown-header");
      //console.log(sections, "sections")
      sections.forEach((s, i) => {
        if (i == chosenSection) {
          s.classList.add("selected-section");
        } else {
          s.classList.remove("selected-section");
        }
      });
      const selectedSection = document.querySelector(".selected-section");
      const allSubs = document.querySelectorAll(".dropdown-item");
      const subsections = selectedSection.querySelectorAll(".dropdown-item");
      allSubs.forEach(subs => {
        subs.classList.remove("active");
      });
      subsections.forEach((s, i) => {
        if (i == chosenSub) {
          s.classList.add("active");
        }
      });
      //console.log(selectedSection, "selectedSection")
    }
  }
};
</script>

<style lang="scss">
#MobileMenu {
  background-color: rgba(0, 0, 0, 0.79);
  max-height: 15vh;
  height: 89px;
  .dropdown {
    width: 56vw;
    margin: 0 3vw 0 5vw;

    .nav-link {
      border: 1px #fff solid;
      border-radius: 5px;
    }
  }
  .section-title .nav-link {
    color: #999944;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  .dropdown-menu {
    max-width: 90vw;
    max-height: 75vh;
    overflow: scroll;
    width: 90vw;
  }
  .dropdown-toggle {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dropdown-header {
    font-size: 0.75rem;
    color: #13322b !important;
    font-weight: 600;
  }
  .dropdown-item {
    white-space: normal;
    font-size: 0.75rem;
  }
  // li .section a {
  //     color: #13322b !important;
  //     font-weight: 600;
  //   }
  // li .subsection a {
  //     color: #000 !important;
  //     font-weight: 300;
  //   }
  .active {
    background-color: #285c4d;
  }
  .nav-link {
    color: #fff;
  }

  .logo-mvdf {
    width: 10vw;
    margin-right: 2vw;
  }
  .logo-ceav {
    width: 20vw;
    margin-right: 5vw;
  }
}
</style>
